import {
    IAtributosEtapa,
    IListarAtributosPorEtapaTipoCaso,
    IVincularAtributo,
} from "../../../Interfaces/Geral/AtributosEtapa/AtributosEtapaInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function AtributosEtapaService(idTipoCaso: number) {
    return Service(
        Axios.get<Array<IAtributosEtapa>>(
            `/home/etapatipocaso/listetapatipocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarEtapaCategoriaAtendimentoTipoCasoService(
    idTipoCaso: number
) {
    return Service(
        Axios.get<Array<IAtributosEtapa>>(
            `/home/etapacategoriaatendimentotipocaso/listaretapacategoriaatendimentotipocaso?idTipoCaso=${idTipoCaso}`
        )
    );
}

export async function ListarAtributosVinculadosPorEtapaTipoCasoService(
    idTipoCaso: number,
    idEtapa: number
) {
    return Service(
        Axios.get<Array<IListarAtributosPorEtapaTipoCaso>>(
            `/home/atributoetapatipocaso/listaratributosporetapatipocaso?idTipocaso=${idTipoCaso}&idEtapa=${idEtapa}`
        )
    );
}

export async function VincularAtributoEtapaTipoCasoService(
    requestBody: Array<IVincularAtributo>
) {
    return Service(
        Axios.post(
            `/home/atributoetapatipocaso/vincularatributoetapatipocaso`,
            requestBody
        )
    );
}

export async function ListarAtributosDesvinculadosPorEtapaTipoCasoService(
    idTipoCaso: number,
    idEtapa: number
) {
    return Service(
        Axios.get<Array<IListarAtributosPorEtapaTipoCaso>>(
            `/home/atributoetapatipocaso/ListarAtributosEtapaTipoCasoDesvinculadosPorEtapa?idTipocaso=${idTipoCaso}&idEtapa=${idEtapa}`
        )
    );
}

export async function DesvincularAtributoEtapaTipoCasoService(
    idAtributoEtapaTipoCaso: number[]
) {
    return Service(
        Axios.put(
            `/home/atributoetapatipocaso/desvincularatributoetapatipocaso`,
            idAtributoEtapaTipoCaso
        )
    );
}

export async function AtualizarAtributoService(requestBody: IVincularAtributo) {
    return Service(
        Axios.put<IListarAtributosPorEtapaTipoCaso>(
            `/home/atributoetapatipocaso/atualizaratributoetapatipocaso`,
            requestBody
        )
    );
}

export async function ListarAtributosPorEtapaTipoCasoObrigatorioService(
    idTipocaso: number,
    idEtapa: number
) {
    return Service(
        Axios.get<Array<IListarAtributosPorEtapaTipoCaso>>(
            `/home/atributoetapatipocaso/listaratributosporetapatipocasoobrigatorio?idTipocaso=${idTipocaso}&idEtapa=${idEtapa}`
        )
    );
}

export async function ListarAtributosPorEtapaTipoCasoRepasseService(
    idTipocaso: number,
    idEtapa: number
) {
    return Service(
        Axios.get<Array<IListarAtributosPorEtapaTipoCaso>>(
            `/home/atributoetapatipocaso/listaratributosporetapatipocasorepasse?idTipocaso=${idTipocaso}&idEtapa=${idEtapa}`
        )
    );
}
